<div class="addon-page">
  <div
    class="empty-state"
    *ngIf="disclaimers && disclaimers.disclaimers?.length === 0"
  >
    <mat-icon class="empty-state__icon">gavel</mat-icon>
    <p>{{ "addons.disclaimers.empty" | translate }}</p>
  </div>

  <div class="content" *ngIf="disclaimers && disclaimers.disclaimers?.length > 0">
    <div *ngFor="let disclaimer of disclaimers.disclaimers">
      <app-disclaimer [disclaimer]="disclaimer"></app-disclaimer>
    </div>
  </div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="!disclaimers">
    <app-loading></app-loading>
  </div>
</div>
